<template>
  <div class="banner home-banner">
    <img src="~@/assets/images/new_home/spbg.jpg" alt="">
    <div class="text">
      <div class="title"><span>全球贸易</span>数智应用平台</div>
      <div class="desc">
        <span>数据精准化</span>
        <span>规则数字化</span>
        <span>专家普惠化</span>
        <span>节税智能化</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeBanner'
}
</script>

<style scoped>
.banner{
  position: relative;
}
img{
  width: 100%;
}
.text{
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
}
.title{
  font-size: 36px;
  margin-bottom: 10px;
  font-weight: bold;
  letter-spacing: 2px;
}
.title span{

  color: #ffa000;
}
.desc{
  font-size: 17px;
  color: rgb(255, 255, 255, .8);
}
.desc span{
  padding: 0 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Banner.vue